import React, { useState, useEffect } from 'react';
import {
    View,
    TextInput,
    TouchableOpacity,
    StyleSheet,
    ActivityIndicator,
    StatusBar,
} from 'react-native';
// `Alert` daqui, nao do react-native: no navegador o Alert do RN e um stub
// vazio e engole tudo em silencio (ver src/utils/appAlert.js). Em nativo e
// reexportacao direta - comportamento do app inalterado.
import { Alert } from '../utils/appAlert';
import { Text } from '../components/ui/AppText';
import { supabase } from '../lib/supabase';
import { useTheme } from '../contexts/ThemeContext';

const ResetPasswordScreen = ({ navigation, route }) => {
    const { isDarkMode } = useTheme();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const colors = {
        bg: isDarkMode ? '#0A0A0F' : '#F8FAFC',
        bgSecondary: isDarkMode ? '#12121A' : '#FFFFFF',
        bgTertiary: isDarkMode ? '#1A1A24' : '#F1F5F9',
        text: isDarkMode ? '#FFFFFF' : '#1F2937',
        textSecondary: isDarkMode ? '#A0A3B1' : '#6B7280',
        border: isDarkMode ? '#2A2D3A' : '#E5E7EB',
        primary: '#3B18C3',
    };

    const handleResetPassword = async () => {
        if (!newPassword || !confirmPassword) {
            Alert.alert('Erro', 'Por favor, preencha todos os campos');
            return;
        }

        if (newPassword !== confirmPassword) {
            Alert.alert('Erro', 'As senhas não coincidem');
            return;
        }

        if (newPassword.length < 6) {
            Alert.alert('Erro', 'A senha deve ter no mínimo 6 caracteres');
            return;
        }

        setLoading(true);

        try {
            const { error } = await supabase.auth.updateUser({
                password: newPassword,
            });

            if (error) throw error;

            Alert.alert(
                'Sucesso! 🎉',
                'Sua senha foi alterada com sucesso!',
                [
                    {
                        text: 'OK',
                        onPress: () => navigation.replace('UserAuth'),
                    },
                ]
            );
        } catch (error) {
            Alert.alert('Erro', error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <View style={[styles.container, { backgroundColor: colors.bg }]}>
            <StatusBar barStyle={isDarkMode ? 'light-content' : 'dark-content'} />

            {/* Header */}
            <View style={[styles.header, { backgroundColor: colors.bgSecondary, borderBottomColor: colors.border }]}>
                <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
                    <Text style={[styles.backIcon, { color: colors.text }]}>←</Text>
                </TouchableOpacity>
                <Text style={[styles.headerTitle, { color: colors.text }]}>Nova Senha</Text>
                <View style={{ width: 40 }} />
            </View>

            <View style={styles.content}>
                {/* Icon and Title */}
                <View style={[styles.iconContainer, { backgroundColor: colors.primary }]}>
                    <Text style={styles.icon}>🔐</Text>
                </View>
                <Text style={[styles.title, { color: colors.text }]}>Redefinir Senha</Text>
                <Text style={[styles.subtitle, { color: colors.textSecondary }]}>
                    Digite sua nova senha abaixo
                </Text>

                {/* Form */}
                <View style={[styles.formCard, { backgroundColor: colors.bgSecondary, borderColor: colors.border }]}>
                    <View style={styles.inputContainer}>
                        <Text style={[styles.inputLabel, { color: colors.textSecondary }]}>Nova Senha</Text>
                        <View style={styles.passwordContainer}>
                            <TextInput
                                style={[styles.input, styles.passwordInput, { backgroundColor: colors.bgTertiary, borderColor: colors.border, color: colors.text }]}
                                placeholder="••••••••"
                                placeholderTextColor={colors.textSecondary}
                                value={newPassword}
                                onChangeText={setNewPassword}
                                secureTextEntry={!showPassword}
                            />
                            <TouchableOpacity style={styles.passwordToggle} onPress={() => setShowPassword(!showPassword)}>
                                <Text style={styles.passwordToggleIcon}>{showPassword ? '🙈' : '👁️'}</Text>
                            </TouchableOpacity>
                        </View>
                    </View>

                    <View style={styles.inputContainer}>
                        <Text style={[styles.inputLabel, { color: colors.textSecondary }]}>Confirmar Nova Senha</Text>
                        <TextInput
                            style={[styles.input, { backgroundColor: colors.bgTertiary, borderColor: colors.border, color: colors.text }]}
                            placeholder="••••••••"
                            placeholderTextColor={colors.textSecondary}
                            value={confirmPassword}
                            onChangeText={setConfirmPassword}
                            secureTextEntry={!showPassword}
                        />
                    </View>

                    <TouchableOpacity
                        style={[styles.mainButton, { backgroundColor: colors.primary }]}
                        onPress={handleResetPassword}
                        disabled={loading}
                    >
                        {loading ? (
                            <ActivityIndicator color="#FFFFFF" />
                        ) : (
                            <Text style={styles.mainButtonText}>Salvar Nova Senha</Text>
                        )}
                    </TouchableOpacity>
                </View>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingTop: 50,
        paddingBottom: 16,
        paddingHorizontal: 16,
        borderBottomWidth: 1,
    },
    backButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
    },
    backIcon: {
        fontSize: 24,
        fontWeight: '300',
    },
    headerTitle: {
        fontSize: 18,
        fontWeight: '700',
    },
    content: {
        flex: 1,
        paddingHorizontal: 20,
        paddingTop: 40,
        alignItems: 'center',
    },
    iconContainer: {
        width: 80,
        height: 80,
        borderRadius: 40,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
    },
    icon: {
        fontSize: 36,
    },
    title: {
        fontSize: 24,
        fontWeight: '800',
        marginBottom: 8,
    },
    subtitle: {
        fontSize: 14,
        textAlign: 'center',
        marginBottom: 32,
    },
    formCard: {
        width: '100%',
        borderRadius: 16,
        padding: 20,
        borderWidth: 1,
    },
    inputContainer: {
        marginBottom: 16,
    },
    inputLabel: {
        fontSize: 13,
        fontWeight: '600',
        marginBottom: 8,
    },
    input: {
        borderRadius: 12,
        paddingHorizontal: 16,
        paddingVertical: 14,
        fontSize: 15,
        borderWidth: 1,
    },
    passwordContainer: {
        position: 'relative',
    },
    passwordInput: {
        paddingRight: 50,
    },
    passwordToggle: {
        position: 'absolute',
        right: 16,
        top: 14,
    },
    passwordToggleIcon: {
        fontSize: 18,
    },
    mainButton: {
        borderRadius: 12,
        paddingVertical: 16,
        alignItems: 'center',
        marginTop: 8,
    },
    mainButtonText: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '700',
    },
});

export default ResetPasswordScreen;
